import { computed, ref } from "vue";
import { getLegalFormsLookup, } from "../infrastructure/adapters/organisationService";
import { logger } from "../../../infrastructure/services/LoggerService";
// Module-scope cache: the INSEE catalogue is static and shared by every legalForm dropdown
// in the app, so we fetch it once and reuse the same promise/value across components.
const entries = ref([]);
let inFlight = null;
/**
 * Single-fetch loader for the INSEE nature_juridique catalogue served by the BFF.
 * The dropdown options are built in the consuming component by mapping the
 * `labelKey` of each entry through `$t()`, so locale switching just works.
 */
export function useLegalFormCatalog() {
    const loading = ref(false);
    async function load() {
        if (entries.value.length > 0)
            return;
        if (inFlight) {
            await inFlight;
            return;
        }
        loading.value = true;
        inFlight = getLegalFormsLookup();
        try {
            entries.value = await inFlight;
        }
        catch (error) {
            logger.error("Failed to load legal forms catalogue", error);
        }
        finally {
            inFlight = null;
            loading.value = false;
        }
    }
    return {
        entries: computed(() => entries.value),
        loading: computed(() => loading.value),
        load,
    };
}
